import React from "react";
import img from "../../../assets/images/about.png";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../submitButton/SubmitButton";

const MissionSection = () => {
  const navigate = useNavigate();

  return (
    <div className="row align-items-center">
      <div className="col-lg-6 pe-lg-0">
        <img
          src={img}
          className="w-100 AuthlandingImg h_550x object-fit-cover br_25"
          alt="About"
        />
      </div>
      <div className="col-lg-6 ps-lg-0">
        <div className="bg-white py-5 px-4 br_10">
          <h5 className="font_13 font_300 text_master2 mb-0">About</h5>
          <h3 className="font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_5 mb-4 text-black">
            Trial Platform 
          </h3>
          <p className="font_14 font_400 line_height1_7 text_light1">
            At Trial Platform, we are redefining how businesses
            automate and accelerate their operations. Our AI-powered solutions
            are built to simplify complex document processing, identity
            verification, and customer interactions — enabling enterprises to
            work smarter, faster, and more securely.
          </p>
          <div className="d-flex">
            <SubmitButton
              style={{ marginTop: "0px" }}
              className="mt-0 mb-0 rounded-pill"
              onClick={() => navigate("/sales-query")}
              label="Contact Us"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
